import { faSpinnerThird } from '@hg-akademie-ban/ban-elevate-assets/icons/solid';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils.js';

import { Icon, type IconSize } from './icon.js';

const loadingSpinnerVariants = cva('animate-spin', {
  variants: {
    variant: {
      brand: 'text-brand',
      knockout: 'text-primary-knockout',
      strong: 'text-primary',
      inherit: '', // ← no color class; inherits from parent
    },
  },
  defaultVariants: {
    variant: 'brand',
  },
});

export type LoadingSpinnerProps = Omit<ComponentProps<'svg'>, 'children'> &
  VariantProps<typeof loadingSpinnerVariants> & {
    children?: never;
    size?: IconSize;
  };

/** A loading spinner icon component. */
export function LoadingSpinner({ className, variant, ...props }: LoadingSpinnerProps) {
  return (
    <Icon
      icon={faSpinnerThird}
      className={cn(loadingSpinnerVariants({ variant, className }))}
      aria-hidden={undefined} // clears Icon's default aria-hidden="true"
      role="status"
      aria-label="Loading"
      data-slot="loading-spinner"
      {...props}
    />
  );
}
